// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"18c36fbe3f2793162d60","883":"7f686f0a2d8170ede928"}[chunkId] + ".js";
};